import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { projectsApi } from '../api/projects';
import Loading from '../components/Common/Loading';
import ErrorMessage from '../components/Common/ErrorMessage';

/**
 * DiscoveryPage - Loads the discovery session for a project,
 * then redirects to the chat interface with that session.
 */
function DiscoveryPage() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadDiscovery() {
      try {
        const discovery = await projectsApi.getDiscovery(projectId);
        navigate(`/chat/${discovery.id}`, { replace: true });
      } catch (err) {
        console.error('[DiscoveryPage] Failed to load discovery session:', err);
        setError(err.message || 'Failed to load discovery session');
      }
    }
    loadDiscovery();
  }, [projectId, navigate]);

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return <Loading />;
}

export default DiscoveryPage;
